import InfoIcon from './InfoIcon'

export default InfoIcon
